import en_US from '../../date-picker/locale/en_US';
export default en_US;


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_antd@3.0.0-beta.7@antd/es/calendar/locale/en_US.js
// module id = 157
// module chunks = 0